import React from "react";
import {Tooltip} from "@mui/material";

interface Props {
    Icon: React.ElementType,
    text: string,
    color?: 'error' | 'warning' | 'info' | 'success' | 'primary' | 'secondary'
}

export const IconWithTooltip = ({Icon, text, color='primary'}: Props) => {

    return (
        <Tooltip title={text}>
            <Icon color={color} />
        </Tooltip>
    )
}